import { ApiResult, ApiConfig } from "common/models";
import { HttpClient } from "common/services/http-client.service";
import { withApiResponse } from "common/utils/rtk-query.util";
import { CONTROLLER } from "common/config/endpoint.config";
import { buildGdxApiUrl } from "common/utils/api.util";

export interface DocumentTypeResponse {
  name: string;
  description: string;
  is_active: boolean;
  is_deleted: boolean;
  id: number;
  created_on: string;
}

export class DocumentTypeService extends HttpClient {
  /**
   * Fetch all document types from the API
   */
  public static getAllDocumentTypes() {
    const config = new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/document-types`),
      "GET",
      undefined,
      undefined
    );

    return withApiResponse<DocumentTypeResponse[]>(async () => {
      const response = await this.invokeApi<DocumentTypeResponse[]>(config);
      return new ApiResult<DocumentTypeResponse[]>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }
}
